import { Options } from "common";
import api from "app/api";
import {PERMISSIONS, ROLES} from "app/constants";

export interface UserListItem {
  id: number;
  email: string;
}
export interface UserFormItem {
  party_id?: number;
  auth_key: string;
  created_at: number;
  email: string;
  email_verified: number; //boolean
  first_name: string;
  id: number;
  last_name: string;
  password_hash: string;
  password_reset_token?: string;
  role: ROLES;
  sf_id?: number;
  status: number;
  timezone: string;
  updated_at: number;
  username: string;
  verify_token?: string;
  permissions: string[];
}

export type UserOptions = Options<"status" | "role" | "permissions">;

export function getUserService() {
  return api.getService<UserFormItem, UserListItem, UserOptions>("users", {
    itemExporter: item => ({ UsersForm: item }),
  });
}

export function getUserLimit() {
  return api.get(`/users/limit`);
}
